var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebookinline = function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0861 15.0917C32.0861 6.75677 24.9575 0 16.1639 0C7.37031 0 0.241699 6.75677 0.241699 15.0917C0.241699 22.6242 6.06419 28.8678 13.6761 30V19.4541H9.63332V15.0917H13.6761V11.7668C13.6761 7.98444 16.0532 5.89518 19.6901 5.89518C21.4316 5.89518 23.2543 6.18994 23.2543 6.18994V9.90391H21.2466C19.2688 9.90391 18.6518 11.0673 18.6518 12.262V15.0917H23.0677L22.3618 19.4541H18.6518V30C26.2636 28.8678 32.0861 22.6242 32.0861 15.0917Z",
    fill: "#172755"
  })));
};

export default SvgFacebookinline;